export default "__VITE_ASSET__Dg7b2yRP__"